export function timeElapsedSinceBirth(dobString: string) {
  const dob = new Date(dobString);
  const now = new Date();
  let years = now.getFullYear() - dob.getFullYear();
  let months = now.getMonth() - dob.getMonth();
  // Adjust years and months if current month is before birth month
  if (months < 0 || (months === 0 && now.getDate() < dob.getDate())) {
    years--;
    months += 12;
  }
  return { years, months };
}

export function getYearsAndMonths(totalMonths: number): string {
  const years = Math.floor(totalMonths / 12);
  const months = totalMonths % 12;
  if (years === 0) {
    return `${months} ${months === 1 ? "month" : "months"}`;
  }
  if (months === 0) {
    return `${years} ${years === 1 ? "year" : "years"}`;
  }
  // return (years === 1) ? `${years} year, ${months} months` : `${years} years, ${months} months`;
  return `${years} ${years === 1 ? "year" : "years"}, ${months} ${months === 1 ? "month" : "months"}`;
}

type MaybeString = string | null | undefined;

export const isNullOrEmpty = (
  s: MaybeString,
): s is Exclude<MaybeString, string> =>
  s === null || s === "" || s === undefined;

type StringOrFalsy = string | false | null | undefined;
export const classNameJoin = (...classes: StringOrFalsy[]) =>
  classes.filter(Boolean).join(" ");

// helper function for transformToPetSummary
export function hasNoAlphanumericCharacters(str: string) {
  const alphanumericRegex = /[a-zA-Z0-9]/;
  return !alphanumericRegex.test(str);
}
